/** Largo de DNI / CUIT al guardar (ABM Clientes y «+ Cliente» de venta). */

export const MSG_DNI_LARGO = "El DNI debe tener entre 7 y 8 dígitos.";
export const MSG_CUIT_LARGO = "El CUIT debe tener 11 dígitos.";

/** Alerta (no bloqueo) al elegir CUIT en un cliente Factura B / consumidor final. */
export const MSG_CUIT_FACTURA_B =
  "Factura B / consumidor final con CUIT se envía a ARCA como DocTipo 80. AFIP rechaza el CAE (10015) si ese CUIT no está en el padrón. Puede continuar si el CUIT es el correcto.";

export type DocumentoBTipo = "cuit" | "dni";

/**
 * Radio por defecto en ABM: Factura B (sin A) o Consumidor Final → DNI.
 * CUIT solo después del modal. Cambiar *a* B / CF vuelve a DNI.
 */
export function defaultDocumentoBTipo(
  tiposPermitidos: readonly string[] | null | undefined,
  condicionIva?: string | null
): DocumentoBTipo {
  const tipos = tiposPermitidos ?? [];
  const bOnly = tipos.includes("B") && !tipos.includes("A");
  const isCf = (condicionIva ?? "").trim() === "Consumidor Final";
  if (bOnly || isCf) return "dni";
  return "cuit";
}

/**
 * True when the ABM would persist a CUIT on a client that emits Factura B
 * (not A). Matches ClientesABM: A y B son excluyentes; el radio CUIT solo
 * aparece con B y sin A.
 */
export function shouldWarnCuitOnFacturaB(
  tiposPermitidos: readonly string[] | null | undefined,
  documentoTipo: "cuit" | "dni"
): boolean {
  const tipos = tiposPermitidos ?? [];
  return tipos.includes("B") && !tipos.includes("A") && documentoTipo === "cuit";
}

export function documentoDigits(value: string | null | undefined): string {
  return (value ?? "").replace(/\D/g, "");
}

export function isDniComplete(dni: string | null | undefined): boolean {
  const n = documentoDigits(dni).length;
  return n >= 7 && n <= 8;
}

export function isCuitComplete(cuit: string | null | undefined): boolean {
  return documentoDigits(cuit).length === 11;
}

export function dniLengthError(dni: string | null | undefined): string {
  const trimmed = (dni ?? "").trim();
  if (!trimmed) return "";
  return isDniComplete(trimmed) ? "" : MSG_DNI_LARGO;
}

export function cuitLengthError(cuit: string | null | undefined): string {
  const trimmed = (cuit ?? "").trim();
  if (!trimmed) return "";
  return isCuitComplete(trimmed) ? "" : MSG_CUIT_LARGO;
}
